import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import {
  Button,
  FlexContainer,
  Icon,
  LoadingPlaceholder,
  Modal,
  Txt,
} from 'components';
import { InventoryContext, useProperty } from 'state';
import { InventoryBlock } from 'components';
import { InventoryAddEdit } from './components';
import styles from './PropertyInventoryScreen.module.scss';

/**
 * PropertyInventoryScreen
 *
 * @return {JSX.Element}
 */
const PropertyInventoryScreen = ({ highlight }) => {
  const ref = useRef();
  const property = useProperty();
  const [modalOpen, setModalOpen] = useState('');
  const { inventory } = property;
  const { isInitialized } = inventory;

  useEffect(() => {
    if (highlight) {
      ref.current.scrollIntoView?.();
    }
  }, [highlight]);

  const { data: dataState } = inventory;

  const handleAddInventory = () => setModalOpen('add');

  const handleEditInventory = (inventoryDoc) => () =>
    setModalOpen(inventoryDoc);

  // const handleViewInventory = (itemUid) => () =>
  //   history.push(
  //     `/properties/view/${propertyUid}/manage/inventory/view/${itemUid}`
  //   );

  const handleDeleteInventory = (inventoryDoc) => () => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      inventoryDoc.delete();
    }
  };

  const handleCloseModal = () => setModalOpen('');

  return isInitialized ? (
    <FlexContainer
      className={classNames(styles.PropertyInventoryScreen)}
      column
      flex
      animate={highlight}
      ref={ref}
    >
      <FlexContainer column gap>
        {dataState?.length ? (
          <FlexContainer gap column>
            {dataState.map((inventoryDoc) => (
              <InventoryBlock
                key={inventoryDoc.data.itemUid}
                imageUrls={inventoryDoc.data.imageUrls}
                date={inventoryDoc.data.dateUpdated}
                title={inventoryDoc.data.title}
                price={inventoryDoc.data.itemCostAmount}
                // onClick={handleViewInventory(i.itemUid)}
                onDelete={handleDeleteInventory(inventoryDoc)}
                onEdit={handleEditInventory(inventoryDoc)}
              />
            ))}
          </FlexContainer>
        ) : null}
        <FlexContainer>
          <Button big flex onClick={handleAddInventory}>
            <FlexContainer spaceBetween alignCenter flex>
              <Txt xx>Add inventory</Txt>
              <Icon name="plus" />
            </FlexContainer>
          </Button>
        </FlexContainer>
      </FlexContainer>
      {modalOpen ? (
        <Modal
          title={'Enter details about this item'}
          onClose={handleCloseModal}
          showCloseButton
        >
          <InventoryContext.Provider
            value={modalOpen === 'add' ? null : modalOpen}
          >
            <InventoryAddEdit onClose={handleCloseModal} />
          </InventoryContext.Provider>
        </Modal>
      ) : null}
    </FlexContainer>
  ) : (
    <LoadingPlaceholder spinner />
  );
};

PropertyInventoryScreen.displayName = 'PropertyInventoryScreen';

export default observer(PropertyInventoryScreen);
